<template>
  <div>
    <!-- <v-card-title></v-card-title> -->
    <v-card-text>
      <v-layout row wrap>
        <div
          v-if="!subtitles.length"
          class="title greyDarken3--text"
        >{{ $t('screener.subtitles.no_data') }}</div>
        <v-spacer></v-spacer>
        <v-btn
          class="primary--text"
          outline
          small
          @click="uploadDialog = true"
        >{{ $t('screener.subtitles.add') }}</v-btn>
      </v-layout>
      <v-data-table
        v-if="subtitles.length"
        :items="subtitles"
        class="elevation-1"
        hide-actions
        hide-headers
      >
        <template v-slot:items="props">
          <tr>
            <td class="body-2">{{ props.item.lang_subtitle }}</td>
            <td class="body-2">
              <a
                target="_blank"
                :href="props.item.src_subtitle"
              >{{ $t('screener.subtitles.view_src') }}</a>
            </td>
            <td class="text-xs-right">
              <v-btn icon @click="confirmDelete(props.item.file_id)">
                <v-icon color="error">$vuetify.icons.rms_delete</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
      <ConfirmationDialog
        v-if="confirm_dialog"
        :dialog="confirm_dialog"
        @confirm="removeMedia()"
        @cancel="confirm_dialog = false; confirm_delete_subtitle_id = null"
      ></ConfirmationDialog>
    </v-card-text>
    <v-dialog v-model="uploadDialog" width="500">
      <v-card class="pa-2">
        <v-card-title>
          <div class="title">{{ $t('screener.subtitles.upload') }}</div>
          <v-spacer></v-spacer>
          <v-btn small dark icon color="grey" :style="{marginRight: '0px'}" @click="onClose">
            <v-icon small>$vuetify.icons.rms_close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-select
            :label="$t('screener.subtitles.choose_lang')"
            :items="default_subtitles"
            v-model="lang_subtitle"
            single-line
          ></v-select>
        </v-card-text>
        <v-card-actions class="px-3">
          <v-spacer></v-spacer>
          <v-btn
            v-if="lang_subtitle"
            color="secondary"
            dark
            @click="show_subtitle_uploader=true"
            class="mx-0"
          >
            <v-icon small>$vuetify.icons.rms_upload</v-icon>
            {{$t('assets_manager.button.upload')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <Uploader
      :show="show_subtitle_uploader"
      :model="film"
      :model_type="DEFINES.MODEL_FILM"
      :mime_type="DEFINES.MIME_TYPE.VTT"
      collection="public"
      :is_subtitle_upload="true"
      :lang_subtitle="lang_subtitle"
      @close="onClose"
    ></Uploader>
  </div>
</template>
<script>
import Uploader from "@/components/media/Uploader";
import ConfirmationDialog from "@/components/dialogBox/Confirmation";

export default {
  name: "Subtitles",
  props: ["film"],
  data() {
    return {
      default_subtitles: [
        {
          text: "English",
          value: "English"
        },
        {
          text: "Hebrew",
          value: "Hebrew"
        },
        {
          text: "Romanian",
          value: "Romanian"
        },
        {
          text: "Spanish",
          value: "Spanish"
        },
        {
          text: "Danish",
          value: "Danish"
        },
        {
          text: "Norwegian",
          value: "Norwegian"
        },
        {
          text: "Romani",
          value: "Romani"
        },
        {
          text: "Swedish",
          value: "Swedish"
        },
        {
          text: "Italian",
          value: "Italian"
        },
        {
          text: "Japanese",
          value: "Japanese"
        },
        {
          text: "German",
          value: "German"
        },
      ],
      lang_subtitle: null,
      show_subtitle_uploader: false,
      uploadDialog: false,
      confirm_dialog: false,
      confirm_delete_subtitle_id: null
    };
  },
  components: {
    Uploader,
    ConfirmationDialog
  },
  computed: {
    subtitles: function() {
      return this.$store.getters["files/getSubtitles"]();
    }
  },

  methods: {
    onClose() {
      this.show_subtitle_uploader = false;
      this.uploadDialog = false;
      this.lang_subtitle = null;
    },

    async removeMedia() {
      try {
        await this.$store.dispatch("files/delete", {
          id: this.confirm_delete_subtitle_id,
          model_type: this.DEFINES.MODEL_FILM,
          model_id: this.film.id
        });
        this.$store.dispatch("app/showMessage", {
          message: this.$t("message.success.deleted"),
          color: this.DEFINES.SNACKBAR_SUCCESS_COLOR
        });
        await this.$store.dispatch("files/get", {
          model_type: "film",
          model_id: this.film.id
        });
        this.confirm_dialog = false;
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error"
        });
      }
    },

    confirmDelete(media_id) {
      this.confirm_dialog = true;
      this.confirm_delete_subtitle_id = media_id;
    },

    getDialogAction(media_id, btn_icon, btn_color, btn_lable) {
      return {
        button_icon: btn_icon,
        button_color: btn_color,
        button_label: btn_lable,
        no_outline: true,
        method: this.removeMedia,
        payload: media_id
      };
    }
  }
};
</script>
